(() => {
  const menuTitleSelector = [
  // 데스크톱 최상위 GNB
  '.header__desktop .navlink--toplevel > .navtext',

  // 모바일 최상위 GNB
  '.drawer__menu[data-sliderule-pane="0"] > .drawer__main-menu > .sliderule__wrapper > .sliderow > .sliderow__title > span:first-child'
  ].join(',');

  const emojiRegex =
    /(?:\p{Regional_Indicator}{2}|[#*0-9]\uFE0F?\u20E3|(?:\p{Emoji_Presentation}|\p{Extended_Pictographic}\uFE0F)(?:\p{Emoji_Modifier})?(?:\u200D(?:\p{Emoji_Presentation}|\p{Extended_Pictographic}\uFE0F)(?:\p{Emoji_Modifier})?)*)/gu;

  function hideDecorativeEmojis(container) {
    const walker = document.createTreeWalker(
      container,
      NodeFilter.SHOW_TEXT,
      {
        acceptNode(node) {
          if (!node.nodeValue.trim()) {
            return NodeFilter.FILTER_REJECT;
          }

          if (node.parentElement?.closest('[data-decorative-emoji]')) {
            return NodeFilter.FILTER_REJECT;
          }

          emojiRegex.lastIndex = 0;

          return emojiRegex.test(node.nodeValue)
            ? NodeFilter.FILTER_ACCEPT
            : NodeFilter.FILTER_REJECT;
        }
      }
    );

    const textNodes = [];

    while (walker.nextNode()) {
      textNodes.push(walker.currentNode);
    }

    textNodes.forEach((textNode) => {
      const text = textNode.nodeValue;
      const fragment = document.createDocumentFragment();

      let lastIndex = 0;
      let match;

      emojiRegex.lastIndex = 0;

      while ((match = emojiRegex.exec(text)) !== null) {
        fragment.append(
          document.createTextNode(text.slice(lastIndex, match.index))
        );

        const emoji = document.createElement('span');

        emoji.setAttribute('aria-hidden', 'true');
        emoji.setAttribute('data-decorative-emoji', '');
        emoji.textContent = match[0];

        fragment.append(emoji);

        lastIndex = match.index + match[0].length;
      }

      fragment.append(
        document.createTextNode(text.slice(lastIndex))
      );

      textNode.replaceWith(fragment);
    });
  }

  function processMenuTitles(root) {
    root
      .querySelectorAll(menuTitleSelector)
      .forEach(hideDecorativeEmojis);
  }

  function initialize() {
    const headerRoot =
      document.querySelector('[data-header-wrapper]') ||
      document.querySelector('.header__wrapper');

    if (!headerRoot) return;

    processMenuTitles(headerRoot);

    const observer = new MutationObserver(() => {
      processMenuTitles(headerRoot);
    });

    observer.observe(headerRoot, {
      childList: true,
      subtree: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize);
  } else {
    initialize();
  }
})();